export const isUserMac = navigator.userAgent.toLowerCase().includes('mac');
export const ctrlKeyString = isUserMac ? '⌘' : '^';
